

import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import LoadingSpinner from "../CommonComponent/loadingSpiner/LoadingSpinner";

export const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return <LoadingSpinner size={80} color={"#000000"}/>; 

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
